import React, { useState } from "react";
import {
  GraduationCap,
  Layers,
  Layout,
  FileText,
  CheckCircle2,
  PlayCircle,
  Lock,
  Search,
  Filter,
  MoreVertical,
  X,
  ArrowRight,
  ShieldCheck,
  Hammer,
  FlaskConical,
  Check,
  ListTodo,
  Copy,
  MessageSquareQuote,
  AlertOctagon,
  BookOpen,
} from "lucide-react";
import { palette, styles, useMediaQuery } from "../theme";
import { ALM_RELEASES } from "../data/adobeData";
import StrategicWorkshopModal from "./StrategicWorkshopModal"; // Ensure this import is correct

// ==========================================
// 1. VISUAL RENDERERS (Dark Mode Wireframes)
// ==========================================

const VisualCatalog = () => (
  <div style={{ display: "flex", gap: 16, width: "100%", height: "100%" }}>
    <div
      style={{
        width: "25%",
        borderRight: "1px solid #334155",
        paddingRight: 16,
      }}
    >
      <div
        style={{
          fontSize: 10,
          fontWeight: 700,
          color: "#94A3B8",
          marginBottom: 12,
          textTransform: "uppercase",
        }}
      >
        Filters
      </div>
      <div style={{ marginBottom: 16 }}>
        <div
          style={{
            fontSize: 11,
            color: "#E2E8F0",
            marginBottom: 6,
            fontWeight: 600,
          }}
        >
          Role
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 6,
            marginBottom: 4,
          }}
        >
          <div
            style={{
              width: 12,
              height: 12,
              border: "1px solid #64748B",
              borderRadius: 3,
              background: "#3B82F6",
            }}
          ></div>
          <span style={{ fontSize: 11, color: "#94A3B8" }}>Account Exec</span>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 6,
            marginBottom: 4,
          }}
        >
          <div
            style={{
              width: 12,
              height: 12,
              border: "1px solid #64748B",
              borderRadius: 3,
            }}
          ></div>
          <span style={{ fontSize: 11, color: "#64748B" }}>Specialist</span>
        </div>
      </div>
      <div>
        <div
          style={{
            fontSize: 11,
            color: "#E2E8F0",
            marginBottom: 6,
            fontWeight: 600,
          }}
        >
          Topic
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 6,
            marginBottom: 4,
          }}
        >
          <div
            style={{
              width: 12,
              height: 12,
              border: "1px solid #64748B",
              borderRadius: 3,
            }}
          ></div>
          <span style={{ fontSize: 11, color: "#64748B" }}>Cloud</span>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 6,
            marginBottom: 4,
          }}
        >
          <div
            style={{
              width: 12,
              height: 12,
              border: "1px solid #64748B",
              borderRadius: 3,
            }}
          ></div>
          <span style={{ fontSize: 11, color: "#64748B" }}>Security</span>
        </div>
      </div>
    </div>
    <div style={{ flex: 1 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 12,
        }}
      >
        <div style={{ fontSize: 14, fontWeight: 700, color: "#FFF" }}>
          Catalog
        </div>
        <Search size={14} color="#64748B" />
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
        {[1, 2, 3, 4].map((i) => (
          <div
            key={i}
            style={{
              background: "#1E293B",
              borderRadius: 6,
              overflow: "hidden",
              border: "1px solid #334155",
            }}
          >
            <div
              style={{
                height: 60,
                background: i === 1 ? "#3B82F6" : "#0F1E36",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {i === 1 && <PlayCircle color="#FFF" size={20} />}
            </div>
            <div style={{ padding: 8 }}>
              <div
                style={{
                  height: 4,
                  width: 40,
                  background: "#C5A059",
                  marginBottom: 6,
                  borderRadius: 2,
                }}
              ></div>
              <div style={{ fontSize: 10, color: "#E2E8F0", fontWeight: 600 }}>
                Product Module {i}
              </div>
              <div style={{ fontSize: 9, color: "#64748B", marginTop: 4 }}>
                20 mins • Video
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

const VisualLearningPath = () => (
  <div style={{ width: "100%" }}>
    <div
      style={{
        background: "#1E293B",
        padding: 16,
        borderRadius: 8,
        border: "1px solid #334155",
        marginBottom: 16,
      }}
    >
      <div
        style={{
          fontSize: 10,
          color: "#C5A059",
          fontWeight: 700,
          textTransform: "uppercase",
          marginBottom: 4,
        }}
      >
        Learning Program
      </div>
      <div
        style={{
          fontSize: 16,
          fontWeight: 700,
          color: "#FFF",
          marginBottom: 4,
        }}
      >
        AE Onboarding: First 30 Days
      </div>
      <div style={{ fontSize: 11, color: "#94A3B8" }}>
        0% Complete • 12 Courses
      </div>
    </div>
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 0,
        paddingLeft: 10,
      }}
    >
      <div
        style={{
          display: "flex",
          gap: 12,
          paddingBottom: 20,
          borderLeft: "2px solid #3B82F6",
        }}
      >
        <div
          style={{
            marginLeft: -7,
            width: 12,
            height: 12,
            borderRadius: "50%",
            background: "#3B82F6",
            border: "2px solid #0F1E36",
          }}
        ></div>
        <div style={{ marginTop: -4, flex: 1 }}>
          <div
            style={{
              background: "#1E293B",
              padding: 10,
              borderRadius: 6,
              border: "1px solid #334155",
            }}
          >
            <div style={{ fontSize: 11, fontWeight: 600, color: "#FFF" }}>
              Week 1: Fundamentals
            </div>
            <div style={{ fontSize: 10, color: "#64748B", marginTop: 2 }}>
              3 Courses • Mandatory
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          gap: 12,
          paddingBottom: 20,
          borderLeft: "2px solid #334155",
        }}
      >
        <div
          style={{
            marginLeft: -7,
            width: 12,
            height: 12,
            borderRadius: "50%",
            background: "#0F1E36",
            border: "2px solid #334155",
          }}
        ></div>
        <div style={{ marginTop: -4, flex: 1 }}>
          <div
            style={{
              background: "#1E293B",
              padding: 10,
              borderRadius: 6,
              border: "1px solid #334155",
              opacity: 0.6,
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div style={{ fontSize: 11, fontWeight: 600, color: "#FFF" }}>
                Month 1: Deep Dives
              </div>
              <Lock size={10} color="#94A3B8" />
            </div>
            <div style={{ fontSize: 10, color: "#64748B", marginTop: 2 }}>
              Locked until Week 1 complete
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const VisualCoursePage = () => (
  <div style={{ width: "100%" }}>
    <div
      style={{
        aspectRatio: "16/9",
        background: "#020617",
        borderRadius: 8,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: 12,
        border: "1px solid #334155",
      }}
    >
      <PlayCircle size={32} color="#E2E8F0" />
    </div>
    <div
      style={{
        display: "flex",
        gap: 12,
        borderBottom: "1px solid #334155",
        paddingBottom: 8,
        marginBottom: 12,
      }}
    >
      <div
        style={{
          fontSize: 11,
          color: "#C5A059",
          fontWeight: 600,
          borderBottom: "2px solid #C5A059",
          paddingBottom: 8,
          marginBottom: -9,
        }}
      >
        Overview
      </div>
      <div style={{ fontSize: 11, color: "#64748B" }}>Resources</div>
      <div style={{ fontSize: 11, color: "#64748B" }}>Quiz</div>
    </div>
    <div
      style={{ fontSize: 14, fontWeight: 700, color: "#FFF", marginBottom: 4 }}
    >
      Introduction to Cloud Security
    </div>
    <div style={{ fontSize: 11, color: "#94A3B8", lineHeight: 1.5 }}>
      This module covers the core value proposition of our cloud suite. You must
      score 80% on the quiz to complete.
    </div>
  </div>
);

const VisualTreviInsertion = () => (
  <div
    style={{ display: "flex", flexDirection: "column", gap: 8, width: "100%" }}
  >
    <div
      style={{
        padding: "12px",
        borderRadius: 6,
        border: "1px solid #334155",
        background: "#1E293B",
        color: "#64748B",
        fontSize: "13px",
      }}
    >
      Module 3: Core Platform
    </div>
    <div
      style={{
        padding: "12px",
        borderRadius: 6,
        border: "1px solid #334155",
        background: "#1E293B",
        color: "#64748B",
        fontSize: "13px",
      }}
    >
      Module 4: Security Add-ons
    </div>
    <div
      style={{
        padding: "16px",
        borderRadius: 8,
        border: "1px solid #C5A059",
        background:
          "linear-gradient(90deg, rgba(197, 160, 89, 0.15) 0%, rgba(15, 30, 54, 0) 100%)",
        color: "#C5A059",
        fontSize: "14px",
        fontWeight: 600,
        display: "flex",
        alignItems: "center",
        gap: 12,
      }}
    >
      <div
        style={{
          background: "#C5A059",
          color: "#0F1E36",
          fontSize: "10px",
          fontWeight: 800,
          padding: "2px 6px",
          borderRadius: 4,
        }}
      >
        NEW
      </div>
      Trevi Launch Module (Required)
    </div>
    <div
      style={{
        padding: "12px",
        borderRadius: 6,
        border: "1px solid #334155",
        background: "#1E293B",
        color: "#64748B",
        fontSize: "13px",
      }}
    >
      Module 5: Legacy Systems
    </div>
  </div>
);

const DefaultVisual = () => (
  <div
    style={{
      height: 200,
      background: "#1E293B",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#64748B",
      fontSize: 12,
      borderRadius: 8,
      border: "1px solid #334155",
    }}
  >
    Wireframe Preview
  </div>
);

// ==========================================
// 2. HELPER COMPONENTS
// ==========================================

const ProgressItem = ({ label, status }) => {
  const getIcon = () => {
    if (status === "done")
      return <CheckCircle2 size={16} color={palette.success} />;
    if (status === "wip")
      return <FlaskConical size={16} color={palette.gold} />;
    return <Lock size={16} color={palette.textSoft} />;
  };
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      {getIcon()}
      <span
        style={{
          fontSize: 12,
          color: status === "locked" ? palette.textSoft : palette.text,
          fontWeight: status === "done" ? 600 : 400,
        }}
      >
        {label}
      </span>
    </div>
  );
};

const StatusBadge = ({ status }) => {
  let bg = "#F1F5F9";
  let color = palette.textSoft;
  let icon = <FlaskConical size={12} />;
  let label = "Sandbox Design";

  if (status === "ready") {
    bg = "#EFF6FF";
    color = "#1E40AF";
    icon = <Hammer size={12} />;
    label = "Ready for ALM Build";
  } else if (status === "implemented") {
    bg = "#ECFDF5";
    color = "#047857";
    icon = <Check size={12} />;
    label = "Implemented in ALM";
  }

  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        padding: "4px 10px",
        borderRadius: 99,
        backgroundColor: bg,
        color: color,
        fontSize: 11,
        fontWeight: 700,
        textTransform: "uppercase",
      }}
    >
      {icon} {label}
    </div>
  );
};

// ==========================================
// 3. MAIN COMPONENT
// ==========================================

export default function AdobeLearningTab() {
  const [selectedWeekId, setSelectedWeekId] = useState(ALM_RELEASES[0].id);
  const [activeArtifact, setActiveArtifact] = useState(null);
  const [showWorkshop, setShowWorkshop] = useState(false); // WORKSHOP STATE
  const isMobile = useMediaQuery("(max-width: 768px)");

  const selectedRelease =
    ALM_RELEASES.find((r) => r.id === selectedWeekId) || ALM_RELEASES[0];

  const renderVisual = (type) => {
    switch (type) {
      case "catalog":
        return <VisualCatalog />;
      case "learning_path":
        return <VisualLearningPath />;
      case "course_page":
        return <VisualCoursePage />;
      case "trevi_launch":
        return <VisualTreviInsertion />;
      default:
        return <DefaultVisual />;
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        backgroundColor: palette.bg,
      }}
    >
      {/* HEADER & CONTEXT */}
      <div
        style={{
          padding: isMobile ? "20px" : "24px 40px",
          borderBottom: `1px solid ${palette.line}`,
          backgroundColor: "#FFF",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            marginBottom: 12,
          }}
        >
          <div style={{ padding: 8, background: "#EFF6FF", borderRadius: 8 }}>
            <GraduationCap size={20} color={palette.navyLight} />
          </div>
          <h1
            style={{
              fontSize: 24,
              fontWeight: 700,
              color: palette.text,
              margin: 0,
              fontFamily: "serif",
            }}
          >
            Architecture Sandbox
          </h1>
        </div>

        {/* STRATEGIC CONTEXT PANEL */}
        <div
          style={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            gap: 24,
            alignItems: "flex-start",
          }}
        >
          <div style={{ flex: 1 }}>
            <div
              style={{
                fontSize: 13,
                color: palette.textSoft,
                lineHeight: 1.5,
                marginBottom: 8,
              }}
            >
              <strong>Why this exists:</strong> This sandbox operationalizes the
              decisions from the Dec 17 alignment with David Yozzi. It serves as
              the design rehearsal space before configuring the production Adobe
              Learning Manager environment.
            </div>
            <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
              <div
                style={{
                  fontSize: 11,
                  background: "#F8FAFC",
                  padding: "4px 8px",
                  borderRadius: 4,
                  color: palette.textSoft,
                }}
              >
                🎯 Product Ed owns Architecture
              </div>
              <div
                style={{
                  fontSize: 11,
                  background: "#F8FAFC",
                  padding: "4px 8px",
                  borderRadius: 4,
                  color: palette.textSoft,
                }}
              >
                🚀 Launches are Modules
              </div>
              <div
                style={{
                  fontSize: 11,
                  background: "#F8FAFC",
                  padding: "4px 8px",
                  borderRadius: 4,
                  color: palette.textSoft,
                }}
              >
                🧱 Scope controlled by Role
              </div>
            </div>
          </div>

          {/* PROGRESS TRACKER */}
          <div
            style={{
              background: "#F8FAFC",
              padding: 12,
              borderRadius: 8,
              minWidth: 200,
              border: `1px solid ${palette.line}`,
            }}
          >
            <div
              style={{
                fontSize: 10,
                fontWeight: 700,
                color: palette.bgSidebar,
                textTransform: "uppercase",
                marginBottom: 8,
              }}
            >
              Architecture Progress
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
              <ProgressItem label="Architecture defined" status="done" />
              <ProgressItem label="Templates created" status="done" />
              <ProgressItem label="Initial paths drafted" status="wip" />
              <ProgressItem label="ALM Configuration" status="wip" />
              <ProgressItem label="Walk Phase (Applied)" status="locked" />
            </div>
          </div>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          flex: 1,
          overflow: "hidden",
          flexDirection: isMobile ? "column" : "row",
        }}
      >
        {/* LEFT: RELEASES LIST */}
        <div
          style={{
            width: isMobile ? "100%" : "280px",
            borderRight: isMobile ? "none" : `1px solid ${palette.line}`,
            borderBottom: isMobile ? `1px solid ${palette.line}` : "none",
            backgroundColor: "#F8FAFC",
            overflowY: "auto",
          }}
        >
          <div style={{ padding: 20 }}>
            <div
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: palette.textSoft,
                marginBottom: 12,
                textTransform: "uppercase",
              }}
            >
              Mockup Releases
            </div>
            {ALM_RELEASES.map((release) => (
              <div
                key={release.id}
                onClick={() => setSelectedWeekId(release.id)}
                style={{
                  padding: 16,
                  borderRadius: 8,
                  marginBottom: 8,
                  cursor: "pointer",
                  backgroundColor:
                    selectedWeekId === release.id ? "#FFFFFF" : "transparent",
                  border:
                    selectedWeekId === release.id
                      ? `1px solid ${palette.line}`
                      : "1px solid transparent",
                  boxShadow:
                    selectedWeekId === release.id
                      ? "0 2px 4px rgba(0,0,0,0.05)"
                      : "none",
                  transition: "all 0.2s",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: 4,
                  }}
                >
                  <div
                    style={{
                      fontSize: 13,
                      fontWeight: 700,
                      color:
                        selectedWeekId === release.id
                          ? palette.bgSidebar
                          : palette.text,
                    }}
                  >
                    {release.label}
                  </div>
                  <div
                    style={{
                      fontSize: 10,
                      background: "#F1F5F9",
                      padding: "2px 6px",
                      borderRadius: 4,
                      color: palette.textSoft,
                    }}
                  >
                    {release.version}
                  </div>
                </div>
                <div style={{ fontSize: 11, color: palette.textSoft }}>
                  {release.theme}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT: ARTIFACTS GRID */}
        <div
          style={{
            flex: 1,
            padding: isMobile ? 20 : 40,
            overflowY: "auto",
            backgroundColor: "#FFF",
          }}
        >
          <div style={{ marginBottom: 32 }}>
            <h2
              style={{
                fontSize: 20,
                fontWeight: 700,
                color: palette.text,
                margin: "0 0 8px 0",
              }}
            >
              {selectedRelease.theme}
            </h2>
            <p
              style={{
                fontSize: 14,
                color: palette.textSoft,
                margin: 0,
                maxWidth: 600,
                lineHeight: 1.5,
              }}
            >
              {selectedRelease.description}
            </p>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: isMobile
                ? "1fr"
                : "repeat(auto-fill, minmax(280px, 1fr))",
              gap: 20,
            }}
          >
            {selectedRelease.artifacts.map((artifact) => (
              <div
                key={artifact.id}
                onClick={() => setActiveArtifact(artifact)}
                style={{
                  border: `1px solid ${palette.line}`,
                  borderRadius: 12,
                  overflow: "hidden",
                  cursor: "pointer",
                  transition: "transform 0.2s",
                  backgroundColor: "#FFF",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.transform = "translateY(-2px)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.transform = "translateY(0)")
                }
              >
                <div
                  style={{
                    height: 140,
                    background: "#0F1E36",
                    padding: 20,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderBottom: `1px solid ${palette.line}`,
                  }}
                >
                  <div style={{ transform: "scale(0.6)", width: "100%" }}>
                    {renderVisual(artifact.visualType)}
                  </div>
                </div>
                <div style={{ padding: 16 }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: 8,
                    }}
                  >
                    <div
                      style={{
                        fontSize: 10,
                        fontWeight: 700,
                        color: palette.gold,
                        textTransform: "uppercase",
                      }}
                    >
                      {artifact.type}
                    </div>
                    <div
                      style={{
                        width: 8,
                        height: 8,
                        borderRadius: "50%",
                        backgroundColor:
                          artifact.status === "implemented"
                            ? "#10B981"
                            : artifact.status === "ready"
                            ? "#3B82F6"
                            : "#E2E8F0",
                      }}
                    />
                  </div>
                  <div
                    style={{
                      fontSize: 14,
                      fontWeight: 700,
                      color: palette.text,
                      marginBottom: 4,
                    }}
                  >
                    {artifact.title}
                  </div>
                  <div style={{ fontSize: 12, color: palette.textSoft }}>
                    Click to inspect build steps
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ARTIFACT MODAL - NOW WITH EXECUTION STEPS & PREREQUISITES */}
      {activeArtifact && (
        <div
          style={{ ...styles.modalOverlay, zIndex: 1400 }}
          onClick={() => setActiveArtifact(null)}
        >
          <div
            style={{
              ...styles.modalContent,
              maxWidth: "1000px",
              height: "85vh",
              backgroundColor: "#FFF",
              color: palette.text,
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modal Header */}
            <div
              style={{
                padding: 24,
                borderBottom: `1px solid ${palette.line}`,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                backgroundColor: "#F8FAFC",
              }}
            >
              <div>
                <div style={{ marginBottom: 8 }}>
                  <StatusBadge status={activeArtifact.status} />
                </div>
                <h3
                  style={{
                    margin: 0,
                    fontSize: 24,
                    fontWeight: 700,
                    fontFamily: "serif",
                    color: palette.bgSidebar,
                  }}
                >
                  {activeArtifact.title}
                </h3>
                <div
                  style={{
                    fontSize: 12,
                    color: palette.textSoft,
                    marginTop: 4,
                  }}
                >
                  Owner: Product Education (Melyssa)
                </div>
              </div>
              <button
                onClick={() => setActiveArtifact(null)}
                style={{
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                <X size={24} color={palette.textSoft} />
              </button>
            </div>

            {/* Modal Body */}
            <div
              style={{
                flex: 1,
                display: "flex",
                overflow: "hidden",
                flexDirection: isMobile ? "column" : "row",
              }}
            >
              {/* LEFT: VISUAL (Fixed Width) */}
              <div
                style={{
                  width: isMobile ? "100%" : "50%",
                  background: "#0F1E36",
                  padding: 40,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "auto",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    maxWidth: 600,
                    boxShadow: "0 20px 50px rgba(0,0,0,0.5)",
                  }}
                >
                  {renderVisual(activeArtifact.visualType)}
                </div>
              </div>

              {/* RIGHT: EXECUTION STEPS (Scrollable) */}
              <div
                style={{
                  flex: 1,
                  background: "#FFF",
                  padding: 32,
                  overflowY: "auto",
                  borderLeft: `1px solid ${palette.line}`,
                }}
              >
                <div style={{ marginBottom: 32 }}>
                  <div
                    style={{
                      fontSize: 11,
                      fontWeight: 700,
                      color: palette.textSoft,
                      textTransform: "uppercase",
                      marginBottom: 8,
                    }}
                  >
                    Why This Exists
                  </div>
                  <p
                    style={{
                      fontSize: 14,
                      lineHeight: 1.6,
                      color: palette.text,
                      margin: 0,
                    }}
                  >
                    {activeArtifact.almContext}
                  </p>
                </div>

                {/* --- 1. PREREQUISITES (Top Priority) --- */}
                {activeArtifact.prerequisites && (
                  <div
                    style={{
                      marginBottom: 32,
                      backgroundColor: "#FFF7ED",
                      border: "1px solid #FED7AA",
                      borderRadius: 8,
                      padding: 16,
                    }}
                  >
                    <div
                      style={{
                        fontSize: 11,
                        fontWeight: 700,
                        color: "#C2410C",
                        textTransform: "uppercase",
                        marginBottom: 12,
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                      }}
                    >
                      <AlertOctagon size={14} /> Pre-Requisites (Blockers)
                    </div>
                    {activeArtifact.prerequisites.map((req, i) => (
                      <div
                        key={i}
                        style={{ display: "flex", gap: 10, marginBottom: 10 }}
                      >
                        {req.status === "done" ? (
                          <CheckCircle2 size={16} color={palette.success} />
                        ) : (
                          <X size={16} color="#C2410C" />
                        )}
                        <div>
                          <div
                            style={{
                              fontSize: 13,
                              fontWeight: 600,
                              color: "#9A3412",
                            }}
                          >
                            {req.title}
                          </div>
                          <div
                            style={{
                              fontSize: 12,
                              color: "#9A3412",
                              opacity: 0.8,
                            }}
                          >
                            {req.desc}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                {/* --- 2. STRATEGIC FRAMEWORK (Tool) --- */}
                {activeArtifact.framework && (
                  <div
                    onClick={() => setShowWorkshop(true)} // --- TRIGGER WORKSHOP ---
                    style={{
                      marginBottom: 32,
                      backgroundColor: "#EFF6FF",
                      border: `1px solid #BFDBFE`,
                      borderRadius: 8,
                      padding: 16,
                      cursor: "pointer",
                      transition: "all 0.2s",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.transform = "translateY(-2px)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.transform = "translateY(0)")
                    }
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: 8,
                      }}
                    >
                      <div
                        style={{
                          fontSize: 11,
                          fontWeight: 700,
                          color: "#1E40AF",
                          textTransform: "uppercase",
                          display: "flex",
                          alignItems: "center",
                          gap: 6,
                        }}
                      >
                        <BookOpen size={14} /> {activeArtifact.framework.title}
                      </div>
                      <div
                        style={{
                          fontSize: 10,
                          background: "#1E40AF",
                          color: "#FFF",
                          padding: "2px 8px",
                          borderRadius: 4,
                        }}
                      >
                        Click to Open Workshop
                      </div>
                    </div>
                    <div
                      style={{
                        fontSize: 13,
                        color: "#1E40AF",
                        marginBottom: 12,
                        lineHeight: 1.4,
                        opacity: 0.9,
                      }}
                    >
                      {activeArtifact.framework.intro}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 8,
                      }}
                    >
                      {activeArtifact.framework.steps.map((s, i) => (
                        <div
                          key={i}
                          style={{
                            background: "#FFF",
                            padding: 8,
                            borderRadius: 6,
                            border: "1px solid #DBEAFE",
                          }}
                        >
                          <div
                            style={{
                              fontSize: 11,
                              fontWeight: 700,
                              color: "#1E40AF",
                              marginBottom: 2,
                            }}
                          >
                            {s.label}
                          </div>
                          <div
                            style={{ fontSize: 12, color: palette.textSoft }}
                          >
                            {s.text}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* --- 3. HOW TO BUILD (Execution) --- */}
                {activeArtifact.almSteps && (
                  <div style={{ marginBottom: 32 }}>
                    <div
                      style={{
                        fontSize: 11,
                        fontWeight: 700,
                        color: palette.bgSidebar,
                        textTransform: "uppercase",
                        marginBottom: 12,
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                      }}
                    >
                      <ListTodo size={14} /> How to Build This in ALM
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 16,
                      }}
                    >
                      {activeArtifact.almSteps.map((step, i) => (
                        <div key={i} style={{ display: "flex", gap: 12 }}>
                          <div
                            style={{
                              width: 24,
                              height: 24,
                              borderRadius: "50%",
                              background: "#F1F5F9",
                              color: palette.textSoft,
                              fontSize: 12,
                              fontWeight: 700,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexShrink: 0,
                            }}
                          >
                            {i + 1}
                          </div>
                          <div>
                            <div
                              style={{
                                fontSize: 13,
                                fontWeight: 600,
                                color: palette.text,
                              }}
                            >
                              {step.label}
                            </div>
                            <div
                              style={{
                                fontSize: 13,
                                color: palette.textSoft,
                                lineHeight: 1.4,
                              }}
                            >
                              {step.desc}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* --- 4. LEADERSHIP UPDATE (Reporting) --- */}
                {activeArtifact.leadershipBrief && (
                  <div
                    style={{
                      padding: 16,
                      backgroundColor: "#F0FDF4",
                      border: "1px solid #BBF7D0",
                      borderRadius: 8,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: 8,
                      }}
                    >
                      <div
                        style={{
                          fontSize: 11,
                          fontWeight: 700,
                          color: "#166534",
                          textTransform: "uppercase",
                          display: "flex",
                          gap: 6,
                          alignItems: "center",
                        }}
                      >
                        <MessageSquareQuote size={12} /> Leadership Update
                      </div>
                      <div
                        style={{
                          fontSize: 10,
                          color: "#166534",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          gap: 4,
                        }}
                      >
                        <Copy size={10} /> Copy
                      </div>
                    </div>
                    <div
                      style={{
                        fontSize: 13,
                        lineHeight: 1.5,
                        color: "#14532D",
                        fontStyle: "italic",
                      }}
                    >
                      "{activeArtifact.leadershipBrief}"
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* WORKSHOP MODAL */}
      {showWorkshop && (
        <StrategicWorkshopModal onClose={() => setShowWorkshop(false)} />
      )}
    </div>
  );
}
